import { HTMLAttributes, FC } from 'react'

interface CarouselItemProps extends HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
  className?: string
}

const CarouselItem: FC<React.PropsWithChildren<CarouselItemProps>> = ({ children, className, ...props }) => {
  return (
    <div className={className} {...props}>
      {children}
    </div>
  )
}

export default CarouselItem
